// 会員登録
import Signup from '../../views/signup/form.vue';

window.Vue.component('signup', Signup);
